// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".rotate_class[data-v-735ba11d]{-webkit-transition:-webkit-transform .3s ease;transition:-webkit-transform .3s ease;transition:transform .3s ease;transition:transform .3s ease,-webkit-transform .3s ease}.success-switch[data-v-735ba11d]  .custom-control-input:checked~.custom-control-label:before,.success-switch[data-v-735ba11d]  .custom-control-input:not(:disabled):active~.custom-control-label:before{background-color:#28a745!important;border-color:#28a745!important}", ""]);
// Exports
module.exports = exports;
